// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1BjsC","avatar":"style_avatar__2VWTM"};